import * as React from 'react';
import './input.scss';
import { PmxComponent } from 'core/components/PmxComponenet';
import { formatCardNumber } from 'core/utils/bankDetecter';

export enum inputType {
    'text',
    'cardNumber',
    'password',
}

interface Props extends PmxComponent {
    disabled?: boolean;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    value: string;
    icon?: React.ReactNode;
    placeholder: string;
    htmlType?: any;
    maxLength?: number;
    type?: inputType;
    dir?: 'ltr' | 'rtl';
    onPressEnter?: () => void;

    required?: boolean;
    label?: string;
    name?: string;
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;

    id?: string;
    /** مقدار ویژگی autocomplete مرورگر، مثلا username / current-password / one-time-code */
    autoComplete?: string;
    inputMode?: 'text' | 'numeric' | 'tel' | 'email' | 'decimal' | 'search' | 'url' | 'none';
    autoFocus?: boolean;
    readOnly?: boolean;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
    onFocus?: React.FocusEventHandler<HTMLInputElement>;
    /** پیام خطای این فیلد؛ زیر باکس نمایش داده و برای screen reader اعلام می‌شود. */
    error?: string;
    /** متن راهنمای کوتاه زیر فیلد (وقتی خطایی وجود ندارد). */
    hint?: string;
}

export const Input: React.FC<Props> = (props) => {
    const generatedId = React.useId();
    const inputId = props.id ?? generatedId;
    const messageId = `${inputId}-message`;
    const message = props.error || props.hint;

    return (
        <div
            className={`pmx-input ${props.disabled ? 'disabled' : ''} ${props.error ? 'has-error' : ''} ${
                props.className ?? ''
            }`}
        >
            {props.label && <label htmlFor={inputId}>{props.label}</label>}
            {props.prefix && <div className={'prefix'}>{props.prefix}</div>}
            <input
                id={inputId}
                type={props.htmlType ?? 'text'}
                value={props.type === inputType.cardNumber ? formatCardNumber(props.value || '') : props.value}
                onKeyUp={(event) => event.key === 'Enter' && props.onPressEnter && !props.disabled && props.onPressEnter()}
                onChange={props.onChange}
                onBlur={props.onBlur}
                onFocus={props.onFocus}
                maxLength={props.maxLength}
                required={props.required}
                placeholder={props.placeholder || ''}
                dir={props.dir || 'rtl'}
                name={props.name || ''}
                autoComplete={props.autoComplete}
                inputMode={props.inputMode}
                autoFocus={props.autoFocus}
                readOnly={props.readOnly}
                aria-invalid={props.error ? true : undefined}
                aria-describedby={message ? messageId : undefined}
            />
            {props.suffix && <div className={'suffix'}>{props.suffix}</div>}
            {props.icon && <div className="adornments">{props.icon}</div>}
            {message && (
                <span
                    id={messageId}
                    className={`pmx-input-message ${props.error ? 'error' : ''}`}
                    role={props.error ? 'alert' : undefined}
                >
                    {message}
                </span>
            )}
        </div>
    );
};
